import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Button, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomDialog from '@ui/components/common/Dialog';
import BDrawer from '@ui/components/common/BDrawer';
const ResponsiveLegalDocumentDialog = ({ open, onClose, title, children }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const actions = (_jsx(Box, { width: '100%', children: _jsx(Button, { variant: 'outlined', color: 'inherit', size: 'large', onClick: onClose, fullWidth: true, children: t('actions.close') }) }));
    const body = _jsx(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 2 }, children: children });
    if (isSmallScreen) {
        return (_jsx(BDrawer, { open: open, onClose: onClose, title: title, anchor: 'bottom', showBottomBar: true, dialogActions: actions, slotProps: {
                backdrop: {
                    sx: {
                        backdropFilter: 'blur(25px)',
                        WebkitBackdropFilter: 'blur(25px)'
                    }
                }
            }, children: _jsx(Box, { sx: { p: 2 }, children: body }) }));
    }
    return (_jsx(CustomDialog, { open: open, onClose: onClose, title: title, maxWidth: 'md', backgroundVariant: 'white', backdropBlur: 25, closeIcon: true, actions: actions, children: _jsx(Box, { sx: { p: 2 }, children: body }) }));
};
export default ResponsiveLegalDocumentDialog;
